(() => {
  function updatePictureAlts() {
    document.querySelectorAll('picture').forEach((picture) => {
      const image = picture.querySelector('img');
      if (!image) return;
      const sources = Array.from(picture.querySelectorAll('source[data-image-alt]'));
      if (!sources.length) return;
      if (!image.hasAttribute('data-default-image-alt')) {
        image.setAttribute('data-default-image-alt', image.alt);
      }
      const source = sources.find((candidate) =>
        !candidate.media || window.matchMedia(candidate.media).matches
      );
      image.alt = source ? source.dataset.imageAlt : image.dataset.defaultImageAlt;
    });
  }

  updatePictureAlts();
  window.addEventListener('resize', updatePictureAlts);
  document.addEventListener('shopify:section:load', updatePictureAlts);
})();
